<template>
  <PageLayout :title="$t('approval.title')" :subtitle="$t('approval.subtitle')">
    <ContentCard>
      <div v-if="loading" class="text-muted">{{ $t('common.loading') }}</div>
      <div v-else-if="pending.length === 0" class="text-center py-5 text-muted">
        <i class="fas fa-check-circle fa-3x mb-3 text-success"></i>
        <p>{{ $t('approval.empty') }}</p>
      </div>
      <div v-else>
        <div v-for="post in pending" :key="post.id" class="approval-card mb-4 p-4 border rounded">
          <div class="d-flex justify-content-between align-items-start mb-2">
            <div>
              <span class="badge badge-light text-capitalize mr-2">{{ post.type }}</span>
              <span v-if="post.ai_generated" class="badge badge-info">{{ $t('approval.ai_generated') }}</span>
            </div>
            <small class="text-muted">@{{ post.social_account?.username }}</small>
          </div>

          <p v-if="post.ai_prompt" class="text-muted small mb-2">
            <i class="fas fa-magic mr-1"></i> {{ $t('common.topic') }}: {{ post.ai_prompt }}
          </p>

          <p class="mb-2">{{ post.caption }}</p>

          <div v-if="post.hashtags?.length" class="mb-3">
            <span v-for="tag in post.hashtags" :key="tag" class="badge badge-secondary mr-1">#{{ tag }}</span>
          </div>

          <div v-if="post.media_urls?.length" class="mb-3">
            <img :src="post.media_urls[0]" class="img-thumbnail" style="max-height: 120px" alt="" />
          </div>

          <div class="row align-items-end">
            <div class="col-md-4 mb-2">
              <label class="small text-muted">{{ $t('approval.schedule_for') }}</label>
              <input v-model="schedules[post.id]" type="datetime-local" class="form-control form-control-sm" />
            </div>
            <div class="col-md-8 mb-2 text-right">
              <button class="btn btn-sm btn-outline-danger mr-2" @click="onReject(post)">
                {{ $t('common.reject') }}
              </button>
              <button class="btn btn-sm btn-success" @click="onApprove(post.id)">
                {{ $t('common.approve') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </ContentCard>
  </PageLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      schedules: {},
    }
  },
  computed: {
    ...mapGetters('posts', ['pending', 'loading']),
  },
  async created() {
    await this.fetchPending()
  },
  methods: {
    ...mapActions('posts', ['fetchPending', 'approvePost', 'rejectPost']),
    async onApprove(id) {
      const scheduledAt = this.schedules[id]
        ? new Date(this.schedules[id]).toISOString()
        : null
      await this.approvePost({ id, scheduledAt })
      await this.fetchPending()
    },
    async onReject(post) {
      const reason = await this.$prompt(this.$t('approval.reject_reason'))
      if (!reason) return
      await this.rejectPost({ id: post.id, reason })
      await this.fetchPending()
    },
  },
}
</script>

<style scoped>
.approval-card {
  background: #fafafa;
}
</style>
